<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import Branches from "../components/Branches.svelte";
	import cakoviceOneImgSm from "../assets/images/branches/cakovice/cakovice-one.jpg?w=400&webp&imagetools";
	import cakoviceOneImgMd from "../assets/images/branches/cakovice/cakovice-one.jpg?w=432&webp&imagetools";
	import cakoviceOneImgLg from "../assets/images/branches/cakovice/cakovice-one.jpg?w=496&webp&imagetools";
	import cakoviceTwoImgSm from "../assets/images/branches/cakovice/cakovice-one.jpg?w=400&webp&imagetools";
	import cakoviceTwoImgMd from "../assets/images/branches/cakovice/cakovice-one.jpg?w=432&webp&imagetools";
	import cakoviceTwoImgLg from "../assets/images/branches/cakovice/cakovice-one.jpg?w=496&webp&imagetools";
	import petrinyBranch from "../assets/images/branches/petriny-branch.jpg";
	import petrinyOneImgSm from "../assets/images/branches/petriny/petriny-one.jpg?w=400&h=400&webp&imagetools";
	import petrinyOneImgMd from "../assets/images/branches/petriny/petriny-one.jpg?w=432&h=432&webp&imagetools";
	import petrinyOneImgLg from "../assets/images/branches/petriny/petriny-one.jpg?w=496&h=496&webp&imagetools";
	import petrinyTwoImgSm from "../assets/images/branches/petriny/petriny-one.jpg?w=400&h=400&webp&imagetools";
	import petrinyTwoImgMd from "../assets/images/branches/petriny/petriny-one.jpg?w=432&h=432&webp&imagetools";
	import petrinyTwoImgLg from "../assets/images/branches/petriny/petriny-one.jpg?w=496&h=496&webp&imagetools";
	import type { ImageSizes } from "../../../core/schema/Image";
	import Glider from "../components/Glider.svelte";
	import { setContext } from "svelte";
	import { thumbnailImageContextKey } from "../contexts/thumbnailImageContextKey.js";
	import type { OurConfectioneryProps } from "./OurConfectioneryProps";

	type $$Props = OurConfectioneryProps;
	const { plannedIceCreams } = $$restProps as $$Props;

	setContext(thumbnailImageContextKey, petrinyBranch);

	const branchGalleries: ImageSizes[][] = [
		[
			{
				sm: cakoviceOneImgSm,
				md: cakoviceOneImgMd,
				lg: cakoviceOneImgLg,
			},
			{
				sm: cakoviceTwoImgSm,
				md: cakoviceTwoImgMd,
				lg: cakoviceTwoImgLg,
			},
		],
		[
			{
				sm: petrinyOneImgSm,
				md: petrinyOneImgMd,
				lg: petrinyOneImgLg,
			},
			{
				sm: petrinyTwoImgSm,
				md: petrinyTwoImgMd,
				lg: petrinyTwoImgLg,
			},
		],
	];
</script>

<Layout>
	<div class="container">
		<section>
			<h1 class="decorative-headline text-center">{nbspify("Naše cukrárny")}</h1>
			<Branches withMap noHeadline {plannedIceCreams} />
		</section>

		<!-- TODO - skryto, dokud nebudou fotky - https://www.figma.com/design/V2hhfLpznllHaLVZcH9Deo?node-id=1136-2417&m=dev#824861598 -->
		<!-- <section>
			<h2 class="decorative-headline !mb-8 lg:!mb-12">Fotogalerie</h2>
			<div
				class="flex flex-col items-center justify-center gap-10 md:flex-row md:items-start md:gap-12 lg:gap-16 xl:gap-[6.5rem]"
			>
				{#each branchGalleries as branchGallery}
					<Glider images={branchGallery} aspectSquare />
				{/each}
			</div>
		</section> -->

		<section class="text-center text-xl font-semibold leading-[1] lg:text-2xl">
			<span>Těšíme se</span>
			<span class="block">na vaši návštěvu!</span>
		</section>
	</div>
</Layout>
